import { IdentifiableObjectDTO } from '@dto/IdentifiableObjectDTO';

export class VisitTypeTimeDTO extends IdentifiableObjectDTO<number> {
  public name: string;

  public time: number;

  public averageDuration: number;
}